import { kitStatuses } from '@/enums/kitItemStatus'
import authService from '@/services/authService'
export default class KitService {
  static canViewReport (kit) {
    return kit?.sampleStatus === kitStatuses.RESULTS_AVAILABLE || kit?.sampleStatus === kitStatuses.MICROBIOME_COACH_SESSION_COMPLETED
  }

  static betaTester (kitReportAvailableDate) {
    return (
      Date.parse(kitReportAvailableDate) >= Date.parse('01/02/2022') &&
      authService.getUserAuthorities().includes('ROLE_BETA')
    )
  }
}
